import { ChatProvider } from "@/components/chat/ChatProvider";
import { Thread } from "@/components/assistant-ui/thread";
import { AppLayout } from "@/components/layout/AppLayout";

const Chat = () => {
  return (
    <AppLayout>
      <div className="flex h-full flex-1 overflow-hidden rounded-2xl border border-border bg-card shadow-card-legal">
        <ChatProvider>
          <Thread />
        </ChatProvider>
      </div>
    </AppLayout>
  );
};

export default Chat;
